import agentStatus from './status';

export default function* () {
    yield* [...agentStatus];
}
